import { saveOfficeData, savePhotoData, deletePhoto } from '../utils/api'

export const RECEIVE_OFFICES = 'RECEIVE_OFFICES'
export const UPDATE_OFFICE = 'UPDATE_OFFICE'
export const UPDATE_PHOTOS = 'UPDATE_PHOTOS'
//export const DELETE_PHOTO = 'DELETE_PHOTO'

export function receiveOffices (offices) {
	return {
		type: RECEIVE_OFFICES,
		offices
	}
}

export function updateOffice (office) {
	return {
		type: UPDATE_OFFICE,
		office
	}
}

export function handleSaveOffice (officeId, data) {
	return (dispatch, getState) => {
		const { authedUser } = getState()
		const userId = authedUser.id

		//dispatch(showLoading())

		return saveOfficeData(
			officeId,
			data,
			userId
		)
		.then((office) => {
			dispatch(updateOffice(office))
		})
		//.then(() => dispatch(hideLoading()))
	}
}

export function updatePhotos (officeId, photos) {
	return {
		type: UPDATE_PHOTOS,
		officeId,
		photos
	}
}

export function handleSavePhoto (officeId, data) {
	return (dispatch, getState) => {
		const { authedUser } = getState()
		const userId = authedUser.id

		return savePhotoData(
			officeId,
			data,
			userId
		)
		.then((photos) => {
			dispatch(updatePhotos(officeId, photos))
		})
	}
}

/*export function onDeletePhoto (officeId, photoId) {
	return {
		type: DELETE_PHOTO,
		officeId,
		photoId
	}
}*/

export function handleDeletePhoto (officeId, photoId) {
	return (dispatch, getState) => {
		const { authedUser } = getState()
		const userId = authedUser.id

		return deletePhoto(
			officeId,
			photoId,
			userId
		)
		.then((photos) => {
			dispatch(updatePhotos(officeId, photos))
		})
	}
}


// WEBPACK FOOTER //
// ./src/actions/offices.js